/*
 * Declare Find a Teacher Container.
 */
var FT = FT || {};

/*
 * Anonymus init function.
 */
(function ($) {

    /*
     * Enable the Algolia plugin when DOM is ready.
     */
    $(document).ready(function () {
        if (FT.settings.form.length > 0) {
            // Settings
            FT.settings.form.algolia({
                onReady: FT.searchReady,
                formValidation: FT.searchFormValidation,
                onSubmit: FT.onSearchSubmit,
                onResults: FT.onSearchResults
            });

            // Validate contact form
            FT.contactFormValidation();

            // Questions Modal
            // FT.questionsModal(); // First version will redirect to a page and not open a modal
        }
    });

    /*
     * Find a Teacher Settings.
     */
    FT.settings = {
        form: $('#findateacher-form'),
        nodeResultsWrapper: $('#find-a-teacher-content'),
        nodeResults: $('#find-a-teacher-results'),
        nodeNoResults: $('#find-a-teacher-no-results'),
        nodeSummary: $('#find-a-teacher-summary'),
        nodeMap: $('#find-a-teacher-map'),
        regexZipCodeCanada: AL.settings.regexZipCodeCanada,
        regexZipCodeCanadaWithNoSpace: AL.settings.regexZipCodeCanadaWithNoSpace,
        regexZipCodeUSA: AL.settings.regexZipCodeUSA,
        badgeUrl: '/RCM/assets/img/certification_badge_3.png',
        badgeAlt: 'certified teacher',
        distanceAriaLabel: '{0} away from current location.',
        distanceLabel: '{0} away',
        discplineAriaLabel: 'A list of the teacher\'s discipline:',
        discplineLabel: 'Discipline:',
        viewProfileLabel: 'View Profile',
        contactLabel: 'Contact',
        tabcontactLabel: 'Contact',
        accordianAddress: 'Address',
        accordianWebsite: 'Website',
        accordianSpecialistLabel: 'Specialist Designation',
        accordianCredentialsLabel: 'Credentials',
        accordianProfessionalDevLabel: 'Professional Development',
        accordianSchoolAssocLabel: 'School Association(s)',
        mapMarkerTeacherUrl: '/RCM/assets/img/teacher_pin.png',
        mapMarkerCertTeacherUrl: '/RCM/assets/img/certteacher_pin.png',
        profileCloseLabel: 'Close profile button. Select this button to reload teachers list.',
        googleRecaptchaApiKey: '6LcX5l8UAAAAAMXeovAyUcJtmWnPKwJQGdzM61rO'
    };

    FT.googleRecaptchaWidgetId = null;
    FT.regionSearched = null;
    FT.searchOnLoad = false;

    /*
     * Search on window load.
     */
    FT.searchReady = function (form) {
        var qsPostalCode = SH.getParameterByName('postal_code'),
            qsDistanceSelect = SH.getParameterByName('distance'),
            qsInstrumentSelect = SH.getParameterByName('instrument'),
            qsDisciplineSelect = SH.getParameterByName('discipline'),
            postalCode = form.find('#edit-postal-code'),
            distanceSelect = form.find('#edit-distance'),
            instrumentSelect = form.find('#edit-instrument'),
            disciplineSelect = form.find('#edit-discipline');

        if (qsPostalCode) {
            postalCode.val(qsPostalCode);
            postalCode.trigger('input');
        }

        if (qsDistanceSelect) {
            distanceSelect.val(qsDistanceSelect);
        }

        if (qsInstrumentSelect && instrumentSelect.length > 0) {
            instrumentSelect.val(qsInstrumentSelect);
        }

        if (qsDisciplineSelect && disciplineSelect.length > 0) {
            disciplineSelect.val(qsDisciplineSelect);
        }

        if (qsPostalCode) {
            setTimeout(function() {
                FT.searchOnLoad = true;
                form.trigger('fake-submit');
            }, 150);
        }
    }

    /*
     * Update brower history.
     */
    FT.updateBrowserHistory = function () {
        var postalCode = FT.settings.form.find('#edit-postal-code'),
            distanceSelect = FT.settings.form.find('#edit-distance'),
            instrumentSelect = FT.settings.form.find('#edit-instrument'),
            disciplineSelect = FT.settings.form.find('#edit-discipline'),
            url = document.location.pathname;

        url += '?postal_code='+ $.trim(postalCode.val());

        if (distanceSelect.length > 0) {
            url += '&distance='+ $.trim(distanceSelect.val());
        }

        if (instrumentSelect.length > 0) {
            url += '&instrument='+ $.trim(instrumentSelect.val());
        }

        if (disciplineSelect.length > 0) {
            url += '&discipline='+ $.trim(disciplineSelect.val());
        }

        if ('undefined' != typeof history && 'undefined' != typeof history.pushState) {
            history.pushState(null, document.title, url);
        }
    }

    /*
     * Update Google Analytics - Trigger new event.
     */
    FT.updateGoogleAnalytics = function (resultsCount) {
        if ('undefined' !== typeof dataLayer) {
            var postalCode = FT.settings.form.find('#edit-postal-code'),
                disciplineSelect = FT.settings.form.find('#edit-discipline');

            postalCode = $.trim(postalCode.val());

            if (FT.settings.regexZipCodeCanada.test(postalCode) && FT.settings.regexZipCodeCanadaWithNoSpace.test(postalCode)) {
                postalCode = postalCode.replace(FT.settings.regexZipCodeCanadaWithNoSpace, '$1 $2');
            }

            if (disciplineSelect.length > 0) {
                disciplineSelect = $.trim(disciplineSelect.val());
            } else {
                disciplineSelect = '';
            }

            dataLayer.push({
                'event': 'eventTracking',
                'eventCategory': 'Find a Teacher Results',
                'eventAction': disciplineSelect + ', ' + postalCode,
                'eventLabel': resultsCount
            });
        }
    }

    /*
     * Validate the form.
     */
    FT.searchFormValidation = function (form) {
        var isFormValid = true,
            postalCode = form.find('#edit-postal-code'),
            distanceSelect = form.find('#edit-distance'),
            instrumentSelect = form.find('#edit-instrument'),
            disciplineSelect = form.find('#edit-discipline');

        postalCode.siblings('.fieldset-error').remove();

        if ($.trim(postalCode.val()).length === 0) {
            postalCode.addClass('highlight');
            postalCode.after('<span class="fieldset-error">Error: empty zip code</span>');
            isFormValid = false;
        } else {
            postalCode.removeClass('highlight');

            if (true != postalCode.data('algoGeoConverted')) {
                postalCode.addClass('highlight');
                postalCode.after('<span class="fieldset-error">Error: invalid zip code</span>');
                isFormValid = false;
            } else {
                postalCode.removeClass('highlight');
            }
        }

        distanceSelect.siblings('.fieldset-error').remove();

        if ($.trim(distanceSelect.val()).length === 0) {
            distanceSelect.addClass('highlight');
            distanceSelect.after('<span class="fieldset-error">Error: empty distance</span>');
            isFormValid = false;
        } else {
            distanceSelect.removeClass('highlight');
        }

        if (instrumentSelect.length > 0) {
            instrumentSelect.siblings('.fieldset-error').remove();

            if ($.trim(instrumentSelect.val()).length === 0) {
                instrumentSelect.addClass('highlight');
                instrumentSelect.after('<span class="fieldset-error">Error: empty instrument</span>');
                isFormValid = false;
            } else {
                instrumentSelect.removeClass('highlight');
            }
        }

        if (disciplineSelect.length > 0) {
            disciplineSelect.siblings('.fieldset-error').remove();

            if ($.trim(disciplineSelect.val()).length === 0 || disciplineSelect[0].selectedIndex === 0) {
                disciplineSelect.addClass('highlight');
                disciplineSelect.after('<span class="fieldset-error">Error: empty instrument</span>');
                isFormValid = false;
            } else {
                disciplineSelect.removeClass('highlight');
            }
        }

        return isFormValid;
    }

    /*
     * Process the search results.
     */
    FT.onSearchSubmit = function () {
        SH.onSearchSubmit();
        FT.updateBrowserHistory();

        // Contact form - Reset the form position
        FT.renderRecaptcha();
        $('.teacher-contact-form').find('input[name="teachernumber"]').val('');
        $('.teacher-contact-form').appendTo($('.fat-contact-teacher-container-base'));
    }

    /*
     * Process the search results.
     */
    FT.onSearchResults = function (result) {
        FT.settings.nodeResults.html('');
        FT.settings.nodeMap.html('');
        FT.settings.nodeResultsWrapper.closest('.fat-section-search').removeClass('search-done');

        FT.regionSearched = 'ca';

        if (FT.settings.regexZipCodeUSA.test($.trim(FT.settings.form.find('#edit-postal-code').val()))) {
            FT.regionSearched = 'us';
        }

        if (result.hits.length > 0) {
            FT.showMap(FT.settings.nodeMap, result.hits);

            $(result.hits).each(function (i, v) {
                FT.createTeacherRow(v).appendTo(FT.settings.nodeResults);
            });

            var postalCode = $.trim(FT.settings.form.find('#edit-postal-code').val()),
                distanceInMeters = $.trim(FT.settings.form.find('#edit-distance option:selected').val()),
                distance = $.trim(FT.settings.form.find('#edit-distance option:selected').text()),
                distanceObj,
                region = FT.regionSearched,
                discipline = $.trim(FT.settings.form.find('#edit-discipline option:selected').text());

            distanceObj = SH.translateDistance(distanceInMeters, region);

            FT.settings.nodeSummary.find('.counter').html(result.nbHits);
            FT.settings.nodeSummary.find('.query').html(discipline);
            FT.settings.nodeSummary.find('.distance').html(distance + distanceObj.unit);
            FT.settings.nodeSummary.find('.zipcode').html(postalCode);

            FT.settings.nodeNoResults.hide();
            FT.settings.nodeSummary.show();
            FT.settings.nodeResultsWrapper.show();

            $('.fat-text-certified-teacher').hide();
            $('.fat-text-certified-teacher-legend').show();

            FT.settings.nodeResultsWrapper.closest('.fat-section-search').addClass('search-done');

            if (FT.searchOnLoad && $('.messages--status').length > 0) {
                FT.searchOnLoad = false;
                $('html, body').animate({scrollTop: $('.messages--status').offset().top - 300}, 250);

                setTimeout(function() {
                    $('.messages--status').fadeOut(function() {
                        $(this).remove();
                    });
                }, 5000);
            } else {
                $('html, body').animate({scrollTop: FT.settings.nodeResultsWrapper.offset().top - 300}, 250);
            }
        } else {
            FT.settings.nodeSummary.find('.counter').html('-');
            FT.settings.nodeSummary.find('.query').html('-');
            FT.settings.nodeSummary.find('.distance').html('-');
            FT.settings.nodeSummary.find('.zipcode').html('-');

            FT.settings.nodeNoResults.show();
            FT.settings.nodeSummary.hide();
            FT.settings.nodeResultsWrapper.hide();

            $('.fat-text-certified-teacher').show();
            $('.fat-text-certified-teacher-legend').hide();

            if (FT.searchOnLoad && $('.messages--status').length > 0) {
                FT.searchOnLoad = false;
                $('html, body').animate({scrollTop: $('.messages--status').offset().top - 300}, 250);

                setTimeout(function() {
                    $('.messages--status').fadeOut(function() {
                        $(this).remove();
                    });
                }, 5000);
            } else {
                $('html, body').animate({scrollTop: FT.settings.nodeNoResults.offset().top - 300}, 250);
            }
        }

        FT.updateScreenElementsByRegion(FT.regionSearched);

        // Contact form - Attribute action
        // $('.teacher-contact-form').find('.fat-fake-form').attr('action', document.location.href);

        SH.hideLoading();

        if ('undefined' !== typeof result.nbHits) {
            FT.updateGoogleAnalytics(result.nbHits);
        }
    }

    /*
     * Process the search map.
     */
    FT.showMap = function (divMap, results) {
        var discipline = $.trim($('#edit-discipline option:selected').text()),
            postalcode = $.trim($('#edit-postal-code').val()),
            mapOptions = {
                zoom: 12,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            },
            map = new google.maps.Map(document.getElementById('find-a-teacher-map'), mapOptions),
            mapGeocoder = new google.maps.Geocoder(),
            infowindow;

        // Check regex Canada - if there is a space between the 3 first and 3 last digits, it removes the space (so Google will find the address)
        if (FT.settings.regexZipCodeCanada.test(postalcode) && !FT.settings.regexZipCodeCanadaWithNoSpace.test(postalcode)) {
            postalcode = postalcode.replace(FT.settings.regexZipCodeCanada, '$1$3');
        }

        mapGeocoder.geocode({ 'address': postalcode }, function(_results, _status) {
            if (_status == 'OK' && postalcode) {
                map.setCenter(_results[0].geometry.location);

                // var marker = new google.maps.Marker({
                //     map: map,
                //     position: _results[0].geometry.location,
                //     icon: FT.settings.mapMarkerTeacherUrl
                // });
            } else {
                if (FT.settings.regexZipCodeCanada.test(postalcode)) {
                    postalcode = postalcode.replace(FT.settings.regexZipCodeCanadaWithNoSpace, '$1 $2');

                    mapGeocoder.geocode({ 'address': postalcode }, function(_results, _status) {
                        if (_status == 'OK' && postalcode) {
                            map.setCenter(_results[0].geometry.location);

                            // var marker = new google.maps.Marker({
                            //     map: map,
                            //     position: _results[0].geometry.location,
                            //     icon: FT.settings.mapMarkerTeacherUrl
                            // });
                        } else {
                            map.setCenter(new google.maps.LatLng(43.6678782, -79.39612319999999));
                        }
                    });
                }
            }
        });

        $(results).each(function (_key, _data) {
            if (_data.objectID && _data.is_certified) {
                var latLng = new google.maps.LatLng(_data._geoloc[0].lat, _data._geoloc[0].lon),
                    marker = new google.maps.Marker({
                        position: latLng,
                        title: _data.full_name,
                        icon: FT.settings.mapMarkerCertTeacherUrl
                    });

                marker.addListener('click', function() {
                    var targetElement = $('[data-nid="' + _data.objectID + '"').first().clone(true, true);
                    targetElement.find('.content-pane').remove();
                    targetElement.addClass('fat-teachers-row-wrapper-map').attr('style', 'max-width:350px;min-width:250px');

                    if (infowindow) {
                        infowindow.close();
                    }

                    infowindow = new google.maps.InfoWindow({
                        content: targetElement.get(0)
                    });

                    infowindow.open(map, marker);
                });

                marker.setMap(map);
            }
        });
    }

    /*
     * Create the Row for a Teacher.
     */
    FT.createTeacherRow = function (teacher) {
        var rowClasses = ['teachers-row', teacher.objectID];

        // Elements declaration
        var profileInfoElements = [];
        var rowElements = [];

        // Global Elements
        var teacherName = $('<h3/>');
        var teacherNameLink = $('<a/>').attr('data-nid', teacher.objectID).attr('tabindex', 0).text(teacher.full_name);

        teacherNameLink.on('click', FT.viewProfile);
        teacherName.append(teacherNameLink);

        var badge = $('<img />').addClass('fat-legacy-badge').attr({
                src: FT.settings.badgeUrl,
                alt: FT.settings.badgeAlt
            });
        var teacherDisciplines = FT.createDisciplineElements(teacher);

        // If certified, display the badge
        if (teacher.is_certified) {
            rowClasses.push('certified');
            teacherName.addClass('certified');

            // Certified Badge
            profileInfoElements.push(badge);
        }

        // Teacher Name
        profileInfoElements.push(teacherName);

        // Meta (Distance)
        profileInfoElements.push(FT.createDistanceElements(teacher));

        // Disciplines
        profileInfoElements.push(teacherDisciplines);

        // Create the Profile Info Wrapper with elements
        var profileInfo = $('<div/>').addClass('profile-info').append(profileInfoElements);

        rowElements.push(profileInfo);

        // Actions (Links)
        rowElements.push(FT.createProfileActionElements(teacher));

        // Content Pane
        var contentPane = FT.createContentPane(teacher, teacherName, badge, teacherDisciplines);

        var row = $('<div/>').addClass(rowClasses.join(' '));
        row.append(rowElements);

        var rowWrapper = $('<div/>').addClass('fat-teachers-row-wrapper').attr('data-nid', teacher.objectID);
        rowWrapper.append(row);
        rowWrapper.append(contentPane);

        return rowWrapper;
    }

    /*
     * Content pane output.
     */
    FT.createContentPane = function (teacher, teacherName, badge, teacherDisciplines) {
        var contentPaneElements = [];
        var contentPane = $('<div/>').addClass('content-pane');

        // Setup the close button
        var closeButtonWrapper = $('<div/>').addClass('close-profile');
        var closeButton = $('<a/>').attr('tabindex', 0).attr('aria-label', FT.settings.profileCloseLabel).text('X');
        closeButton.on('click', FT.closeContentPane);
        closeButtonWrapper.append(closeButton);
        contentPane.append(closeButtonWrapper);

        // *** HEADER

        var headerContainer = $('<div/>').addClass('teacher-header-container');

        // Badge
        if (teacher.is_certified) {
            headerContainer.append(badge.clone());
        }

        // Name
        headerContainer.append(
            $('<h2/>')
                .addClass(teacherName.attr('class'))
                .append(teacherName.html())
        );

        contentPaneElements.push(headerContainer);

        // *** INFO

        // Information Container
        var teacherInfoContainer = $('<div/>').addClass('teacher-info-container');

        if (teacher.is_certified || teacher.is_examiner || teacher.has_arct || teacher.num_first_class_honours_students) {
            // Badges

            var badges = $('<div/>').addClass('teacher-header-badges');

            if (teacher.is_certified) {
                var badge = $('<div/>').addClass('badge-item badge-item-certified').text('Certified Teacher');
                badge.appendTo(badges);
            }

            if (teacher.is_examiner) {
                var badge = $('<div/>').addClass('badge-item badge-item-examiner').text('RCM Examiner');
                badge.appendTo(badges);
            }

            if (teacher.has_lrct) {
                var badge = $('<div/>').addClass('badge-item badge-item-arct-lcrt').text('LRCM');
                badge.appendTo(badges);
            } else if (teacher.has_arct) {
                var badge = $('<div/>').addClass('badge-item badge-item-arct-lcrt').text('ARCT');
                badge.appendTo(badges);
            }

            // For now hide the First Class Honor Students badge
            // if (teacher.num_first_class_honours_students) {
            //     var badge = $('<div/>').addClass('badge-item badge-item-first-class-students').html('<span class="badge-item-first-class-students-counter">' + teacher.num_first_class_honours_students + '</span> First Class Honor Students');
            //     badge.appendTo(badges);
            // }

            badges.appendTo(teacherInfoContainer);
        }

        // Disciplines
        var disciplines = teacherDisciplines.clone();
        disciplines.find('.hide').remove();
        disciplines.attr('class', 'teachers-item');
        disciplines.find('.label-discpline').attr('class', 'teachers-label');
        disciplines.find('.teachers-label').text((disciplines.find('.teachers-label').text()).replace(':', 's'));
        disciplines.find('.disciplines').attr('class', 'teachers-value no-bullet');
        disciplines.appendTo(teacherInfoContainer);

        if (teacher.is_certified && teacher.show_public_profile_optin) {
            // Address
            var teacherInfoAddressText = '';
            if ('' != $.trim(teacher.address_name)) {
                teacherInfoAddressText += teacher.address_name;
            }
            if ('' != $.trim(teacher.street)) {
                teacherInfoAddressText +=  ' ' + teacher.street;
            }
            if ('' != $.trim(teacher.city)) {
                teacherInfoAddressText += ', ' + teacher.city;
            }
            if ('' != $.trim(teacher.province)) {
                teacherInfoAddressText += ' ' + teacher.province;
            }
            if ('' != $.trim(teacher.country)) {
                teacherInfoAddressText += ', ' + teacher.country;
            }
            if ('' != $.trim(teacher.postal_code)) {
                teacherInfoAddressText += ', ' + teacher.postal_code;
            }
            teacherInfoAddressText = $.trim(teacherInfoAddressText);

            if ('' != teacherInfoAddressText) {
                var addressContent = $('<li/>').html(teacherInfoAddressText);
                var address = FT.createModalItemElement(FT.settings.accordianAddress, addressContent);
                address.appendTo(teacherInfoContainer);
            }

            //Website
            if (teacher.teacher_website) {
                var websiteHref = teacher.teacher_website;
                if (!(new RegExp('^https?:\/\/')).test(websiteHref)) {
                    websiteHref = 'http://' + websiteHref;
                }
                var websiteContent = $('<li/>').append(
                    $('<a/>').attr('target', '_blank').attr('href', websiteHref).html(teacher.teacher_website)
                );
                var website = FT.createModalItemElement(FT.settings.accordianWebsite, websiteContent);
                website.appendTo(teacherInfoContainer);
            }

            // Specialist Designation
            if (teacher.designations.length > 0) {
                var teacherDesignationsContent = [];

                $(teacher.designations).each(function () {
                    teacherDesignationsContent.push(
                        $('<li/>').text(this.subjectname + ' - ' + this.levelname)
                    );
                });

                var teacherDesignations = FT.createModalItemElement(FT.settings.accordianSpecialistLabel, teacherDesignationsContent);
                teacherDesignations.appendTo(teacherInfoContainer);
            }

            // Credentials
            if (teacher.show_credentials_optin && teacher.credentials.length > 0) {
                var teacherCredentialsContent = [];

                $(teacher.credentials).each(function () {
                    teacherCredentialsContent.push(
                        $('<li/>').text(this.yearawarded + ' - ' + this.degree_diploma + ' - ' + this.institution)
                    );
                });

                var teacherCredentials = FT.createModalItemElement(FT.settings.accordianCredentialsLabel, teacherCredentialsContent);
                teacherCredentials.appendTo(teacherInfoContainer);
            }

            // Professional Development
            if (teacher.show_professional_development_optin && teacher.professional_development.length > 0) {
                var teacherProfessionalDevContent = [];

                $(teacher.professional_development).each(function () {
                    teacherProfessionalDevContent.push(
                        $('<li/>').text(this.coursetitle + ' - ' + this.description + ' - ' + this.year)
                    );
                });

                var teacherProfessionalDev = FT.createModalItemElement(FT.settings.accordianProfessionalDevLabel, teacherProfessionalDevContent);
                teacherProfessionalDev.appendTo(teacherInfoContainer);
            }

            // School Associations
            if (teacher.show_teacher_associations_optin && teacher.associations.length > 0) {
                var teacherAssociationsContent = [];

                $(teacher.associations).each(function () {
                    teacherAssociationsContent.push(
                        $('<li/>').text(this.associationname + ' - ' + this.associationtypename)
                    );
                });

                var teacherAssociations = FT.createModalItemElement(FT.settings.accordianSchoolAssocLabel, teacherAssociationsContent);
                teacherAssociations.appendTo(teacherInfoContainer);
            }
        } else {
            contentPane.addClass('content-pane-single-column');
        }

        contentPaneElements.push(teacherInfoContainer);

        // *** CONTACT

        var teacherContactContainer = $('<div/>').addClass('contact-teacher-container');

        //Display the tab "Contact"
        $('<h3/>')
            .addClass('contact' + (teacher.is_certified ? ' certified' : ''))
            .text(FT.settings.tabcontactLabel)
            .appendTo(teacherContactContainer);

        contentPaneElements.push(teacherContactContainer);

        // *** WRAP...

        contentPane.append(contentPaneElements);

        return contentPane;
    }

    /*
     * Distance output.
     */
    FT.createDistanceElements = function (teacher) {
        if (teacher._rankingInfo) {
            var distanceInMeters = teacher._rankingInfo.geoDistance;
            var region = teacher.country.toLowerCase();
            var distanceObj = SH.translateDistance(distanceInMeters, region);

            var combined = distanceObj.distance + distanceObj.unit;
            var span = $('<span/>').addClass('distance').attr('aria-label', FT.settings.distanceAriaLabel.replace('{0}', combined)).text(FT.settings.distanceLabel.replace('{0}', combined));

            return $('<div/>').addClass('meta').append(span);
        }

        return '';
    }

    /*
     * Create List of Disciplines.
     */
    FT.createDisciplineElements = function (teacher) {
        if (teacher.disciplines && teacher.disciplines.constructor === Array && teacher.disciplines.length > 0) {
            var container = $('<div/>').addClass('teachers-discpline');

            container.append(
                $('<div/>').addClass('label-discpline').text(FT.settings.discplineLabel)
            );

            container.append(
                $('<h4/>').addClass('hide').text(FT.settings.discplineAriaLabel)
            );

            var list = $('<ul/>').addClass('disciplines no-bullet');

            $(teacher.disciplines).each(function (i, v) {
                list.append($('<li/>').text(v));
            });

            container.append(list);

            return container;
        }

        return '';
    }

    /*
     * Create the View Profile and Contact.
     */
    FT.createProfileActionElements = function (teacher) {
        var container = $('<div/>').addClass('profile-contact').attr('data-nid', teacher.objectID);

        // Badges

        if (teacher.is_certified) {
            var badge = $('<div/>').addClass('fat-badge-2 fat-badge-2-certified');
            container.append(badge);
        }

        if (teacher.is_examiner) {
            var badge = $('<div/>').addClass('fat-badge-2 fat-badge-2-examiner');
            container.append(badge);
        }

        if (teacher.has_arct) {
            var badge = $('<div/>').addClass('fat-badge-2 fat-badge-2-arct-lcrt');
            container.append(badge);
        }

        // For now hide the First Class Honor Students badge
        // if (teacher.num_first_class_honours_students) {
        //     var badge = $('<div/>').addClass('fat-badge-2 fat-badge-2-first-class-students').text(teacher.num_first_class_honours_students);
        //     container.append(badge);
        // }

        // Contact CTA

        var contact = $('<div/>').addClass('contact-profile').attr('data-nid', teacher.objectID);
        var contactLink = $('<a/>').addClass('btn-view-contact').attr('data-nid', teacher.objectID).attr('tabindex', 0).text(FT.settings.contactLabel);

        contactLink.on('click', FT.viewProfile);

        contact.append(contactLink);
        container.append(contact);

        return container;
    }

    /*
     * Create a modal item element.
     */
    FT.createModalItemElement = function (aLabel, content) {
        var item = $('<div/>')
            .addClass('teachers-item')
            .append(
                $('<div/>').addClass('teachers-label').html(aLabel)
            )
            .append(
                $('<ul/>').addClass('teachers-value no-bullet').html(content)
            );

        return item;
    }

    /*
     * Display the content.
     */
    FT.viewProfile = function (e) {
        e.preventDefault();

        var cta = $(this);
        var nid = cta.data('nid');
        var contentPageWrapper = cta.closest('.fat-teachers-row-wrapper');

        if (contentPageWrapper.hasClass('fat-teachers-row-wrapper-map')) {
            contentPageWrapper = $('.fat-search-content .fat-teachers-row-wrapper[data-nid="' + nid + '"]');
            cta = contentPageWrapper.find('.view-profile');
        }

        // Overlay
        $('.fat-section-search').addClass('fat-section-search-with-modal-open');
        $('.fat-teachers-overlay').remove();
        contentPageWrapper.prepend(
            $('<div />').addClass('fat-teachers-overlay').on('click', FT.closeContentPane)
        );

        // Contact form - Moves the form to the correct place
        FT.renderRecaptcha();
        $('.teacher-contact-form').find('input[name="teachernumber"]').val(nid);
        $('.teacher-contact-form').appendTo(contentPageWrapper.find('.contact-teacher-container'));

        // Adds the active-teacher css class which makes the item not hidden
        contentPageWrapper.toggleClass('active-teacher');
        contentPageWrapper.find('.content-pane').show().appendTo(FT.settings.nodeResultsWrapper);

        $('html, body').animate({ scrollTop: $('.content-pane:visible').offset().top - 24 }, 'slow');
    }

    /*
     * Close the content pane.
     */
    FT.closeContentPane = function (e) {
        e.preventDefault();

        var contentPageWrapper = $('.fat-teachers-row-wrapper.active-teacher');
        var cta = contentPageWrapper.find('.close-profile');

        // Overlay
        $('.fat-teachers-overlay').remove();
        $('.fat-section-search').removeClass('fat-section-search-with-modal-open');

        // Show all the list items
        contentPageWrapper.find('.teachers-row').removeClass('hidden');
        contentPageWrapper.closest('.view-content').children('.fat-teachers-row-wrapper').toggleClass('hidden');

        // Hide the content pane
        $('.content-pane:visible').hide().appendTo(contentPageWrapper);
        contentPageWrapper.toggleClass('active-teacher');

        // Toggle active item contact/informatiom
        contentPageWrapper.find('.information').removeClass('active');
        contentPageWrapper.find('.contact').removeClass('active');
    }

    /*
     * Accordion click.
     */
    FT.accordion = function (e) {
        e.preventDefault();

        $(this).closest('.row-accordian').find('.accordian').slideToggle('fast');
        var $state = $(this).closest('.row-accordian').find('.state');

        if ($state.html() == '+') {
            $state.html('-');
        } else {
            $state.html('+');
        }
    }

    /*
     * Validate contact form.
     */
    FT.contactFormValidation = function () {
        // Fake submit because Kentico doesn't allow other forms on the page
        $(document).on('click', '.teacher-contact-form .fat-fake-form [type="submit"]', function(e) {
            e.preventDefault();
            $(this).closest('.fat-fake-form').trigger('fake-submit');
        });

        // On contact form submit
        $(document).on('fake-submit', '.teacher-contact-form .fat-fake-form', function(e) {
            e.preventDefault();

            // Form
            var $form = $(this).closest('.teacher-contact-form'),
                isFormValid = true,
                firstName = $form.find('input[name="first_name"]'),
                lastName = $form.find('input[name="last_name"]'),
                email = $form.find('input[name="email"]'),
                message = $form.find('textarea[name="message"]'),
                topQuestions = $form.find('input[name="top_questions"]'),
                subject = $form.find('input[name="subject"]'),
                teacherId = $form.find('input[name="teachernumber"]'),
                recaptcha = $form.find('textarea[name="g-recaptcha-response"]');

            firstName.siblings('.fieldset-error').remove();
            if ($.trim(firstName.val()).length === 0) {
                firstName.addClass('highlight');
                firstName.after('<span class="fieldset-error">Error: required field</span>');
                isFormValid = false;
            } else {
                firstName.removeClass('highlight');
            }

            lastName.siblings('.fieldset-error').remove();
            if ($.trim(lastName.val()).length === 0) {
                lastName.addClass('highlight');
                lastName.after('<span class="fieldset-error">Error: required field</span>');
                isFormValid = false;
            } else {
                lastName.removeClass('highlight');
            }

            email.siblings('.fieldset-error').remove();
            if ($.trim(email.val()).length === 0) {
                email.addClass('highlight');
                email.after('<span class="fieldset-error">Error: required field</span>');
                isFormValid = false;
            } else {
                email.removeClass('highlight');
            }

            message.siblings('.fieldset-error').remove();
            if ($.trim(message.val()).length === 0) {
                message.addClass('highlight');
                message.after('<span class="fieldset-error">Error: required field</span>');
                isFormValid = false;
            } else {
                message.removeClass('highlight');
            }

            if (!isFormValid) {
                return false;
            }

            // Top Questions checkbox (trigger)
            if (!topQuestions.is(':checked')) {
                alert('Please, you need to agree to receive teacher correspondence and other RCM communications, including "Top 10 Interview Questions to Ask Music Teachers". You can unsubscribe at any time.');
                topQuestions.focus();
                return false;
            }

            // Captcha
            if (FT.googleRecaptchaWidgetId) {
                if (!grecaptcha.getResponse(FT.googleRecaptchaWidgetId)) {
                    alert('Please, check the option "I\'m not a robot" before continue.');
                    return false;
                }
            }

            var fields = {
                'first_name' : firstName.val(),
                'last_name' : lastName.val(),
                'email' : email.val(),
                'subject' : subject.val(),
                'message' : message.val(),

                // Checkbox required to send the form
                'top_questions' : topQuestions.is(':checked') ? '1' : '0',

                // Teacher ID
                'teachernumber' : teacherId.val(),

                // Recaptcha (JS)
                'g-recaptcha-response' : recaptcha.val(),
            };

            fields = $.param(fields);

            // Show loading
            SH.displayLoading();

            $.ajax({
                type: 'POST',
                url: (document.location.host == 'rcm-k-dev.pixelshopdesign.net')
                        ? 'https://dev.rcmusic.com/teacher-contact/send-message'
                        : 'https://acquia-drupal-registration-service.rcmusic.com/teacher-contact/send-message',
                crossDomain: true,
                data: fields,

                success: function(responseData, textStatus, jqXHR) {
                    // Hide loading
                    SH.hideLoading();

                    // Close modal
                    $('.fat-teachers-overlay').trigger('click');

                    if (responseData.success) {
                        alert('Success!');

                        if ('undefined' !== typeof dataLayer) {
                            dataLayer.push({
                                'event': 'eventTracking',
                                'eventCategory': 'Forms',
                                'eventAction': 'Submit',
                                'eventLabel': 'Contact Teacher'
                            });
                        }
                    } else if (responseData.error && responseData.message) {
                        alert(responseData.message);
                    } else {
                        alert('Error!');
                    }
                },

                error: function (responseData, textStatus, errorThrown) {
                    // Hide loading
                    SH.hideLoading();

                    alert('Error!');
                }
            });

            return true;
        });

        // // Top Questions checkbox (part 1/2)
        // $('.teacher-contact-form .fat-fake-form input[name="top_questions"]').on('invalid', function(e) {
        //     e.target.setCustomValidity('');

        //     if (!e.target.validity.valid) {
        //         e.target.setCustomValidity('Please check this box in order to proceed. You can unsubscribe at any time.');
        //     }
        // });

        // // Top Questions checkbox (part 2/2)
        // $('.teacher-contact-form .fat-fake-form input[name="top_questions"]').on('input', function(e) {
        //     e.target.setCustomValidity('');
        // });
    }

    /*
     * Add/render Google recaptcha.
     */
    FT.renderRecaptcha = function () {
        if ('undefined' == typeof grecaptcha) {
            return false;
        }

        if (FT.googleRecaptchaWidgetId) {
            grecaptcha.reset(FT.googleRecaptchaWidgetId);
        } else {
            $('.teacher-contact-form').find('#google-recaptcha').remove();
            $('.teacher-contact-form').find('input[type="submit"]').before('<div id="google-recaptcha"></div>');

            FT.googleRecaptchaWidgetId = grecaptcha.render('google-recaptcha', {
                'sitekey': FT.settings.googleRecaptchaApiKey,

                'callback' : function(response) {
                    if ($(document).width() < 992) {
                        $('html, body').animate({ scrollTop: $('.content-pane:visible .form-item-message').offset().top - 24 }, 'slow');
                    }
                }
            });
        }
    }

    /*
     * Add top questions modal effect/cta.
     */
    FT.questionsModal = function () {
        $(document).on('click', '.fat-section-email .fat-button', function (e) {
            e.preventDefault();

            // Overlay
            $('#find-a-teacher').addClass('view-teachers-with-modal-open');
            $('.fat-teachers-overlay').remove();
            $('#find-a-teacher').prepend(
                $('<div />').addClass('fat-teachers-overlay').on('click', FT.closeQuestionsModal)
            );

            // Modal / Form
            var modal = $('<div />').addClass('fat-top-questions-form');

            var closeButtonWrapper = $('<div/>').addClass('close-profile');
            var closeButton = $('<a/>').attr('tabindex', 0).text('X');
            closeButton.on('click', FT.closeQuestionsModal);
            closeButtonWrapper.append(closeButton);
            closeButtonWrapper.appendTo(modal);

            var form = $('.teacher-top-questions-form');
            form.appendTo(modal);

            modal.appendTo($('#find-a-teacher'));
        });
    }

    /*
     * Close top questions modal.
     */
    FT.closeQuestionsModal = function (e) {
        e.preventDefault();

        // Overlay
        $('.fat-teachers-overlay').remove();
        $('#find-a-teacher').removeClass('view-teachers-with-modal-open');

        // Form - Reset the form position
        $('.teacher-top-questions-form').appendTo($('.fat-top-questions-teacher-container-base'));

        // Modal
        $('.fat-top-questions-form').remove();
    }

    /*
     * Update screen elements by region searched.
     */
    FT.updateScreenElementsByRegion = function (region) {
        // For now hide the First Class Honor Students badge
        // if (region == 'us') {
        //     $('.fat-badge-first-class-students, .fat-badge-2-first-class-students, .badge-item-first-class-students').hide();
        // } else {
        //     $('.fat-badge-first-class-students, .fat-badge-2-first-class-students, .badge-item-first-class-students').show();
        // }
    }

})(jQuery);
